import store from '@/store/store'
import axios from 'axios'
import { vue } from '@/main.js'
import router from '@/router.js'

const api = axios.create({
  baseURL: 'https://esusfeedback.com.br/api',
})
api.interceptors.request.use(
  function (config) {
    config.headers.authorization = 'Bearer ' + store.state.accessToken

    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

const apiPublic = axios.create({
  baseURL: 'https://esusfeedback.com.br/api',
})

api.interceptors.response.use(
  (response) => {
    if (response.status === 200 || response.status === 201) {
      return Promise.resolve(response)
    } else return Promise.reject(response)
  },
  (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(error)
    }
    if (error.response !== undefined) {
      if (error.response.status === 401 || error.response.status === 403) {
        store.dispatch('logout')
        vue.$router.push('/login')
        if (error.response.data.message === 'Expired token') {
          vue.$toast.error(
            'Sessão expirada! Por favor, faça login novamente.',
            'Atenção',
            {
              position: 'topRight',
            }
          )
        }
      }
      if (error.config.returnReject) {
        return Promise.reject(error)
      }
    }
  }
)

export { api, apiPublic }
